export enum DFCActiveCampaignTags {
    CANCELLED_PAID = 29,
    FREE_MEMBER = 20,
    NEW_PREMIUM = 18,
    PREMIUM_MEMBER = 35,
    PREMIUM_PLUS_MEMBER = 36,
    LIFETIME_MEMBER = 34,
    WEBSITE_SIGNUP = 10,
    AFFILIATE_PROGRAM_LEAD = 37,
    APPROVED_AFFILIATE = 38,
    NO_DEPARTURE_AIRPORT = 39,
    DOLLAR_FLIGHT_CLUB = 52,
    ON_TRIAL= 674,
    MARKED_UNPAID = 679,
    ON_WAITLIST = 732,
    COMPLETED_WAITLIST = 734,
    ENDED_WAITLIST_EARLY = 733,
    SIGNUP_PROCESS_2025 = 735,
    INTERESTED_IN_PRICE_DROP_TRACKING = 789,
    INTERESTED_IN_REFERRAL_PROGRAM = 799
}